import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { URL_STORAGE_SUPABASE } from '../const'

import { useLogin } from '../context/LoginContext'
import { useProfessional } from '../context/ProfessionalContext'

import ContainerBox from '../components/common/ContainerBox'
import TableData from '../components/common/TableData'
import TitleBox from '../components/common/TitleBox'
import Button from '../components/common/Button'
import Modal from '../components/common/Modal'
import { IconEdit, IconPdf, IconPlus, IconTrash } from '../components/icons/Icons'
import ProfessionalsForm from '../components/forms/ProfessionalsForm'
import DropdownFilter from '../components/common/DropdownFilter'
import InputCheckFilter from '../components/common/InputCheckFilter'
import ButtonExport from '../components/common/ButtonExport'

const ProfesionalesPage = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [idData, setIdData] = useState(null);
    const [filtro, setFiltro] = useState({
        arbitrator: false,
        adjudicator: false,
        active: false,
        inactive: false,
    });
    const navigate = useNavigate()
    const { user } = useLogin();
    const { professionals, getProfessionals, updateProfessional, modal, getModal } = useProfessional()

    useEffect(() => {
        if (user !== null) {
            navigate('/arbitros')
        }
        getProfessionals()
    }, [user])

    const openModal = (id = null) => {
        setIsModalOpen(true);
        setIdData(id)
        getModal()
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const columns = [
        {
            header: '#',
            cell: ({ cell }) => {
                const { row } = cell;
                return <div>{row.index + 1}</div>
            }
        },
        {
            header: 'Apellidos y nombres',
            cell: ({ cell }) => {
                return <div>{cell.row.original.last_name + ', ' + cell.row.original.first_name}</div>
            }
        },
        {
            header: 'Vigencia',
            accessorKey: 'validity'
        },
        {
            header: 'RNA OSCE',
            cell: ({ cell }) => {
                const osce = cell.row.original.osce
                return <span className={`flex items-center justify-center text-xs capitalize text-white rounded-full w-14 h-5 ${osce === true ? 'bg-primary ' : 'bg-secondary/40'}`}>
                    {osce ? 'Si' : 'No'}
                </span>
            }
        },
        {
            header: 'Estado',
            cell: ({ cell }) => {
                const status = cell.row.original.status
                const id = cell.row.original.id
                return <button
                    className={`flex items-center justify-center text-xs capitalize text-white rounded-full w-14 h-5 ${status === true ? 'bg-success ' : 'bg-danger/40'}`}
                    type='button'
                    onClick={() => handleActiveChange(id, status)}
                >
                    {status ? 'Activo' : 'Inactivo'}
                </button>
            }
        },
        {
            header: 'Acciones',
            cell: ({ cell }) => {
                const id = cell.row.original.id
                const cv = cell.row.original.cv
                return <div className='flex items-center'>
                    <a
                        href={URL_STORAGE_SUPABASE + 'cv/' + cv}
                        target='_blank'
                        rel='noreferrer'
                        className={`${cv !== "" ? `bg-primary/80 hover:bg-primary border-primary/80` : `bg-secondary/30 border-secondary/10`} border text-xs text-white px-3 py-1 rounded-sm`}
                        title='Curriculum'
                        alt={cv}
                    >
                        <IconPdf className='w-4' />
                    </a>
                    <button
                        className="bg-warning/80 hover:bg-warning border border-warning/80 text-xs text-black/50 px-3 py-1 rounded-sm"
                        title='Editar'
                        onClick={() => openModal(id)}
                    >
                        <IconEdit className='w-4' />
                    </button>
                    <button
                        className="bg-danger/90 hover:bg-danger border border-danger/90 text-xs text-white px-3 py-1 rounded-sm"
                        title='Eliminar'
                        onClick={openModal}
                    >
                        <IconTrash className='w-4' />
                    </button>
                </div>
            }
        }
    ];

    const handleActiveChange = async (id, status) => {
        const formDataStatus = {
            status: !status
        }
        await updateProfessional(formDataStatus, id)
    }

    const handleCheckboxChange = (event) => {
        const { name, checked } = event.target;
        setFiltro({ ...filtro, [name]: checked });
    };

    const usuariosFiltrados = professionals.filter((professional) => {
        if (filtro.arbitrator && !professional.arbitrator) {
            return false;
        }
        if (filtro.adjudicator && !professional.adjudicator) {
            return false;
        }
        if (filtro.active && professional.status !== true) {
            return false;
        }
        if (filtro.inactive && professional.status !== false) {
            return false;
        }
        if (filtro.osce && !professional.osce) {
            return false;
        }
        if (filtro.lista && !professional.add_list) {
            return false;
        }
        return true;
    });

    const handleExportData = () => {}

    return (
        <>
            <TitleBox title='Relación de árbitros / adjudicadores' />
            <ContainerBox>
                <Button value='Nuevo' openModal={() => openModal()}>
                    <IconPlus className='w-4' />
                </Button>
                <TableData columns={columns} data={usuariosFiltrados} >
                    <div className='flex items-center gap-2'>
                        <DropdownFilter width={'w-[400px]'}>
                            <div className='grid grid-cols-3 gap-2'>
                                <ul className="p-2 space-y-1">
                                    <InputCheckFilter
                                        name='arbitrator'
                                        checked={filtro.arbitrator}
                                        onChange={handleCheckboxChange}
                                        text={'Árbitros'}
                                    />
                                    <InputCheckFilter
                                        name='adjudicator'
                                        checked={filtro.adjudicator}
                                        onChange={handleCheckboxChange}
                                        text={'Adjudicadores'}
                                    />
                                </ul>
                                <ul className="p-2 space-y-1">
                                    <InputCheckFilter
                                        name='osce'
                                        checked={filtro.osce}
                                        onChange={handleCheckboxChange}
                                        text={'RNA OSCE'}
                                    />
                                    <InputCheckFilter
                                        name='lista'
                                        checked={filtro.lista}
                                        onChange={handleCheckboxChange}
                                        text={'En lista'}
                                    />
                                </ul>
                                <ul className="p-2 space-y-1">
                                    <InputCheckFilter
                                        name='active'
                                        checked={filtro.active}
                                        onChange={handleCheckboxChange}
                                        text={'Activos'}
                                    />
                                    <InputCheckFilter
                                        name='inactive'
                                        checked={filtro.inactive}
                                        onChange={handleCheckboxChange}
                                        text={'Inactivos'}
                                    />
                                </ul>
                            </div>
                        </DropdownFilter>
                        <ButtonExport onClick={() => handleExportData()} />
                    </div>
                </TableData>
            </ContainerBox>
            <Modal isOpen={isModalOpen} onClose={closeModal} isModal={modal} title={"Nuevo registro"}>
                <ProfessionalsForm idData={idData} />
            </Modal>
        </>
    )
}

export default ProfesionalesPage